import {
  type PaymentScheduleInput,
  type PaymentStageInput,
} from '@/gql/graphql';
import {
  type StoredPaymentSchedule,
  type StoredPaymentScheduleStage,
} from '@payaca/types/payment-schedule';

export const toPaymentScheduleInput = (
  paymentSchedule: StoredPaymentSchedule
): PaymentScheduleInput => ({
  explainer: paymentSchedule.explainer,
  stages: paymentSchedule.stages.map(toPaymentStageInput),
});

const toPaymentStageInput = (
  stage: StoredPaymentScheduleStage
): PaymentStageInput => {
  if (stage.type === 'instalment') {
    const { description, percentageDue } = stage;
    return { instalment: { description, percentageDue } };
  }

  const { description, basis } = stage;
  return {
    deposit: {
      description,
      basis:
        basis.type === 'percentage'
          ? { percentage: basis.percentageDue }
          : {
              fixed: {
                fixedAmount: basis.fixedAmount,
                percentageCap: basis.percentageCap,
              },
            },
    },
  };
};
